//Prize Images Mob


import PrizeImage1 from 'assets/images/campaign/prizes/players/jillscott/player-jill-colour-mob.png';
import PrizeImage2  from 'assets/images/campaign/prizes/players/laurenjames/player-lauren-colour-mob.png';
import PrizeImage3 from 'assets/images/campaign/prizes/players/katiemccabe/player-katie-colour-mob.png';
import PrizeImage4 from 'assets/images/campaign/prizes/players/leahwilliamson/player-leah-colour-mob.png';

import PrizeImage1x2 from 'assets/images/campaign/prizes/players/jillscott/player-jill-colour-mob@2x.png';
import PrizeImage2x2 from 'assets/images/campaign/prizes/players/laurenjames/player-lauren-colour-mob@2x.png';
import PrizeImage3x2 from 'assets/images/campaign/prizes/players/katiemccabe/player-katie-colour-mob@2x.png';
import PrizeImage4x2 from 'assets/images/campaign/prizes/players/leahwilliamson/player-leah-colour-mob@2x.png';

//Prize Images Desk

import PrizeImage1Desk from 'assets/images/campaign/prizes/players/jillscott/player-jill-colour-desk.png';
import PrizeImage2Desk from 'assets/images/campaign/prizes/players/laurenjames/player-lauren-colour-desk.png';
import PrizeImage3Desk  from 'assets/images/campaign/prizes/players/katiemccabe/player-katie-colour-desk.png';
import PrizeImage4Desk  from 'assets/images/campaign/prizes/players/leahwilliamson/player-leah-colour-desk.png';

import PrizeImage1Deskx2 from 'assets/images/campaign/prizes/players/jillscott/player-jill-colour-desk@2x.png';
import PrizeImage2Deskx2 from 'assets/images/campaign/prizes/players/laurenjames/player-lauren-colour-desk@2x.png';
import PrizeImage3Deskx2 from 'assets/images/campaign/prizes/players/katiemccabe/player-katie-colour-desk@2x.png';
import PrizeImage4Deskx2 from 'assets/images/campaign/prizes/players/leahwilliamson/player-leah-colour-desk@2x.png';

//Prize Videos

import JillVideo from 'assets/videos/jillscott-mob.mp4';
import JillVideoDesk from 'assets/videos/jillscott-desk.mp4';
import LaurenVideo from 'assets/videos/laurenjames-mob.mp4';
import LaurenVideoDesk from 'assets/videos/laurenjames-desk.mp4';
import KatieVideo from 'assets/videos/katiemccabe-mob.mp4';
import KatieVideoDesk from 'assets/videos/katiemccabe-desk.mp4';
import LeahVideo from 'assets/videos/leahwilliamson-mob.mp4';
import LeahVideoDesk from 'assets/videos/leahwilliamson-desk.mp4';




//import PrizeImage1Video from 'assets/videos/56023646-003_1g_H&AWins_Player_Selection-568x682_VVD_2024.mp4';
//import PrizeImage2Video from 'assets/videos/56023646-003_1g_H&AWins_Player_Selection-568x682_LW_2024.mp4';
//import PrizeImage3Video from 'assets/videos/56023646-003_1g_H&AWins_Player_Selection-568x682_HK_2024.mp4';
//import PrizeImage4Video from 'assets/videos/56023646-003_1g_H&AWins_Player_Selection-568x682_NJ_2024.mp4';



const prizeList = [
  { 
    "id": "JS", 
    "image": PrizeImage1, 
    "image2x": PrizeImage1x2, 
    "imageDesk": PrizeImage1Desk, 
    "imageDesk2x": PrizeImage1Deskx2,  
    //"videoSelected" : PrizeImage1Video, 
    "type": "vertical", 
    "title": "Jill",
    "name": "Jill Scott",
    "video": JillVideo,
    "videoDesk": JillVideoDesk
  },
  { 
    "id": "LJ", 
    "image": PrizeImage2, 
    "image2x": PrizeImage2x2, 
    "imageDesk": PrizeImage2Desk, 
    "imageDesk2x": PrizeImage2Deskx2, 
    //"videoSelected" : PrizeImage1Video, 
    "type": "vertical", 
    "title": "Lauren",
    "name": "Lauren James",
    "video": LaurenVideo,
    "videoDesk": LaurenVideoDesk
  },
  { 
    "id": "KMC", 
    "image": PrizeImage3, 
    "image2x": PrizeImage3x2, 
    "imageDesk": PrizeImage3Desk, 
    "imageDesk2x": PrizeImage3Deskx2, 
    //"videoSelected" : PrizeImage1Video, 
    "type": "vertical", 
    "title": "Katie",
    "name": "Katie McCabe",
    "video": KatieVideo,
    "videoDesk": KatieVideoDesk
  },
  { 
    "id": "LW", 
    "image": PrizeImage4, 
    "image2x": PrizeImage4x2, 
    "imageDesk": PrizeImage4Desk, 
    "imageDesk2x": PrizeImage4Deskx2, 
    //"videoSelected" : PrizeImage1Video, 
    "type": "vertical", 
    "title": "Leah",
    "name": "Leah Williamson",
    "video": LeahVideo,
    "videoDesk": LeahVideoDesk
  },
  
  
]

export default prizeList;